<template>
  <div class="mdl-grid">
    <div class="mdl-cell mdl-cell--6-col mdl-cell--8-col-tablet">Mis Reportes 6 (8 tablet)</div>
    <div class="mdl-cell mdl-cell--4-col mdl-cell--6-col-tablet">Mis Reportes 4 (6 tablet)</div>
    <div class="mdl-cell mdl-cell--2-col mdl-cell--4-col-phone">Mis Reportes 2 (4 phone)</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'Mis Reportes'
    }
  },
  mounted () {
    this.$title.show(this.title)
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// index.vue?1fc7d6ca